<!-- 父母行为红绿灯卡 && 价值观卡 图画 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div class="game-1-box">
        <div class="game-1-box-title">
          当前：第{{ swiperIndex }}/{{ list.length }}页
        </div>
        <div class="game-1-box-list">
          <!-- 左右滑动，一个Swipeitem中有8张图片，一行4个 -->
          <Swipe
            ref="cardSwiper"
            :show-indicators="false"
            :loop="false"
            @change="swiperChange"
          >
            <template v-for="(item, index) in list">
              <SwipeItem :key="index">
                <Grid :column-num="sizeType != 'small' ? 3 : 4" :border="false">
                  <GridItem
                    v-for="(subitem, subindex) in item"
                    :key="subindex"
                    v-show="!selectIdList.includes(subitem.id)"
                    @dblclick.native="doubleSelectCardHandle(subitem)"
                  >
                    <div
                      class="game-1-box-list-card-item"
                      :class="{
                        active: activeCard == subitem.id,
                        small: sizeType == 'small',
                        middle: sizeType == 'middle',
                      }"
                      @click="activeCard = subitem.id"
                    >
                      <VanImage
                        height="100%"
                        :src="
                          subitem.isFront != 1
                            ? subitem.reverseImg
                            : subitem.frontImg
                        "
                        fit="fill"
                        radius="5"
                      />

                      <div
                        class="game-1-box-list-card-item-open"
                        @click.stop="previewImgHandle(subitem)"
                      >
                        <Icon name="search" size="0.3rem" />
                      </div>
                    </div>
                  </GridItem>
                </Grid>
              </SwipeItem>
            </template>
          </Swipe>
          <template v-if="gameStatus == 1">
            <div
              class="game-1-box-list-control"
              style="
                margin-top: 0.2rem;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <img
                class="game-1-box-list-control-swiper"
                @click="changeSwiper(-1)"
                src="@/assets/game/pre.png"
              />

              <NfButton
                color="rgb(255,211,94)"
                width="3rem"
                round=".5rem"
                @click.native="selectCardHandle"
                >选择卡片</NfButton
              >

              <img
                class="game-1-box-list-control-swiper"
                @click="changeSwiper(1)"
                src="@/assets/game/next.png"
              />
            </div>
          </template>

          <div class="game-1-box-list-divider"></div>

          <div class="game-1-box-list-select">
            <Grid :column-num="sizeType != 'small' ? 3 : 4" :border="false">
              <GridItem
                v-for="(subitem, subindex) in selectCardList"
                :key="subindex"
              >
                <div
                  class="game-1-box-list-select-card-item"
                  :class="{
                    active: selectActiveCard == subitem.id,
                    small: sizeType == 'small',
                    middle: sizeType == 'middle',
                  }"
                  @click="selectActiveCard = subitem.id"
                >
                  <VanImage
                    height="100%"
                    :src="
                      subitem.isFront != 1
                        ? subitem.reverseImg
                        : subitem.frontImg
                    "
                    fit="cover"
                    radius="5"
                  />
                </div>
              </GridItem>
            </Grid>
            <!-- 选中的卡片按钮 -->
            <div class="game-1-box-list-select-btns" v-show="gameStatus == 1">
              <NfButton
                color="rgb(255,211,94)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="revertCardHandle"
                >放回卡片</NfButton
              >

              <NfButton
                color="rgb(172,185,233)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="confirmHandle"
                >确认选择</NfButton
              >
            </div>
          </div>
        </div>
      </div>

      <div></div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Button as VantButton,
  Image,
  Icon,
  ImagePreview,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";

export default {
  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sizeType: {
      type: String,
      default: "big",
    },
    gameStatus: {
      type: Number,
      default: 0,
    },
  },
  mounted() {},
  data() {
    return {
      activeCard: null,
      selectActiveCard: 0,
      selectCardList: [],
      list: [],
      swiperIndex: 1,
      // 当前选择的所有卡牌ID
      selectIdList: [],
    };
  },
  methods: {
    // 选择卡牌
    selectCardHandle() {
      // 如果超出最大可抽取的数量则提示
      if (
        this.formValue.playerCardList[this.formValue.roleTab].length >=
        this.gameInfo.extractNum
      ) {
        this.$dialog.message(
          "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
        );
        return;
      }

      const item = this.cardList.find((item) => item.id == this.activeCard);
      if (!this.activeCard) {
        this.$dialog.message("请选择卡牌");
        return;
      }
      // 已存在则返回
      const isExist = this.formValue.playerCardList[
        this.formValue.roleTab
      ].find((item) => item.id == this.activeCard);
      if (isExist) {
        this.$dialog.message("卡牌已存在");
        return;
      }
      this.formValue.playerCardList[this.formValue.roleTab].push({
        ...item,
      });
    },
    // 双击选择卡牌
    doubleSelectCardHandle(item) {
      // 如果超出最大可抽取的数量则提示
      if (
        this.formValue.playerCardList[this.formValue.roleTab].length >=
        this.gameInfo.extractNum
      ) {
        this.$dialog.message(
          "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
        );
        return;
      }
      // 已存在则返回
      const isExist = this.formValue.playerCardList[
        this.formValue.roleTab
      ].find((item) => item.id == this.activeCard);
      if (isExist) {
        this.$dialog.message("卡牌已存在");
        return;
      }
      this.formValue.playerCardList[this.formValue.roleTab].push({
        ...item,
      });
    },
    // 放回卡牌
    revertCardHandle() {
      if (this.formValue.successSaveUser.includes(this.formValue.roleTab)) {
        this.$dialog.message("该玩家已记录");
        return;
      }
      const index = this.formValue.playerCardList[
        this.formValue.roleTab
      ].findIndex((item) => item.id == this.selectActiveCard);
      if (index != -1) {
        this.formValue.playerCardList[this.formValue.roleTab].splice(index, 1);
      } else {
        this.$dialog.message("请选择需要放回的卡牌");
      }
    },
    // 确认选择
    confirmHandle() {
      if (this.formValue.successSaveUser.includes(this.formValue.roleTab)) {
        this.$dialog.message("该玩家已记录");
        return;
      }

      const data = this.formValue.playerCardList[this.formValue.roleTab].map(
        (item) => {
          return {
            cardId: item.id,
            cardName: item.cardName,
            cateId: item.cateId,
            cateName: item.cateName,
            createTime: item.createTime,
            secondCateId: item.secondCateId,
            secondCateName: item.secondCateName,
            roundId: this.gameInfo.gameRoundId,
            gameId: this.gameInfo.gameId,
            playerId: this.formValue.roleTab,
            playerName: this.formValue.roleName,
            userId: this.userInfo.uid,
          };
        }
      );
      this.$emit("confirm", data);
    },
    changeList() {
      const list = [];
      let arr = [];
      if (this.sizeType == "small") {
        this.cardList.forEach((item, index) => {
          arr.push({
            ...item,
          });
          if ((index + 1) % 8 == 0) {
            list.push(arr);
            arr = [];
          }
          // 如果是最后一张
          if (index == this.cardList.length - 1) {
            list.push(arr);
          }
        });
      } else {
        // 否则6
        this.cardList.forEach((item, index) => {
          arr.push({
            ...item,
          });
          if ((index + 1) % 6 == 0) {
            list.push(arr);
            arr = [];
          }
          // 如果是最后一张
          if (index == this.cardList.length - 1) {
            list.push(arr);
          }
        });
      }

      this.list = list;
    },
    swiperChange(index) {
      this.swiperIndex = index + 1;
    },
    changeSwiper(type) {
      if (type == "-1") {
        this.$refs.cardSwiper.prev();
      } else {
        this.$refs.cardSwiper.next();
      }
    },
    previewImgHandle(item) {
      const img = item.isFront != 1 ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    VantButton,
    Image,
    Icon,
    ImagePreview,
  },
  computed: {
    // list: {
    //   get() {
    //     const list = [];
    //     let arr = [];
    //     this.cardList.forEach((item, index) => {
    //       arr.push({
    //         ...item,
    //       });
    //       if ((index + 1) % 8 == 0) {
    //         list.push(arr);
    //         arr = [];
    //       }
    //       // 如果是最后一张
    //       if (index == this.cardList.length - 1) {
    //         list.push(arr);
    //       }
    //     });
    //     console.log("list55555555", list, arr);
    //     return list;
    //   },
    // },
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  watch: {
    "formValue.roleTab"(val) {
      // this.selectCardList = val;
      this.activeCard = null;
      this.selectCardList = this.formValue.playerCardList[val];
    },
    "formValue.playerCardList": {
      handler(val) {
        this.selectCardList = val[this.formValue.roleTab];
      },
      immediate: true,
      deep: true,
    },
    sizeType: {
      handler(val) {
        this.changeList();
      },
      immediate: true,
      deep: true,
    },
    cardList: {
      handler(val) {
        this.changeList();
      },
      immediate: true,
      deep: true,
    },
    selectCardList: {
      // 统计ID
      handler(val) {
        this.selectIdList = val.map((item) => item.id);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }

        &-card-item {
          box-sizing: border-box;
          border-radius: 0.2rem;
          overflow: hidden;
          height: 2.8rem;
        }

        .active {
          border: 0.06rem solid #666eee;
        }
      }

      &-card-item {
        box-sizing: border-box;
        border-radius: 0.2rem;
        // overflow: hidden;
        height: 2.8rem;

        position: relative;

        &-open {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          border-radius: 50%;
          width: 0.6rem;
          height: 0.6rem;
          background: #eee;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      &-control {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.2rem;
        &-swiper {
          width: 0.6rem;
          height: 0.6rem;

          &:active {
            transform: scale(0.98);
          }
        }
      }

      .small {
        height: 2.2rem;
      }

      .middle {
        height: 2.5rem;
      }
      .active {
        border: 0.06rem solid #666eee;
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}

::v-deep .van-grid-item__content {
  background-color: inherit !important;
}

::v-deep .van-grid {
  justify-content: center;
}
</style>
